import { Badge } from "@/components/ui/badge";
import { Sun } from "lucide-react";
import { cn } from "@/lib/utils";

interface MbBadgeSunProps {
  children: React.ReactNode;
  className?: string;
}

export function MbBadgeSun({ children, className }: MbBadgeSunProps) {
  return (
    <Badge
      className={cn(
        "bg-accent text-accent-foreground font-semibold text-base px-4 py-2 gap-2",
        className
      )}
    >
      <Sun className="w-4 h-4" />
      {children}
    </Badge>
  );
}
